// extracted by mini-css-extract-plugin
module.exports = {"insights":"Cards_insights__QdEyF"};